export default "<div class=\"sender__box\">\n  <div class=\"chat-sender__box\">\n    <span>{{ chat }}</span>\n  </div>\n</div>\n"